import React from 'react';

import { formatDefaultDateAndTime, formatDefaultDateOnly } from '@shared/lib/utils';

import { Tooltip } from './Tooltip';

export interface DateTimeShortProps {
  dateTime: string | number;
  className?: string;
}

export const DateTimeShort = React.memo(({ dateTime, className }: DateTimeShortProps) => {
  const formatted = formatDefaultDateAndTime(dateTime);
  return (
    <time dateTime={String(dateTime)} className={className}>
      {formatted}
    </time>
  );
});
DateTimeShort.displayName = 'DateTimeShort';

export interface DateShortProps {
  date: string | number;
  className?: string;
}

export const DateShort = React.memo(({ date, className }: DateShortProps) => {
  // Shared browser-locale date formatter — short dates in lists match the date part of
  // formatDefaultDateAndTime used by headers (e.g. both MM/DD/YYYY in en-US).
  const short = formatDefaultDateOnly(date);
  const full = formatDefaultDateAndTime(date);

  return (
    <Tooltip content={full}>
      <time dateTime={String(date)} className={className}>
        {short}
      </time>
    </Tooltip>
  );
});
DateShort.displayName = 'DateShort';
